import { jsx as _jsx } from "react/jsx-runtime";
/**
 * 日志上下文
 * 为应用提供日志服务访问
 *
 * 核心功能：
 * 1. 提供日志服务的上下文
 * 2. 提供日志提供者组件
 * 3. 通过上下文机制向组件树提供日志功能
 */
import { createContext } from 'react';
import { LoggerService } from '../services/logger.service.js';
/**
 * 创建日志上下文
 * 初始值为null，将在Provider中设置
 */
export const LoggingContext = createContext(null);
/**
 * 日志服务提供者组件
 * 为组件树提供日志服务访问
 */
export const LoggingProvider = ({ children }) => {
    // 获取日志服务单例
    const logger = LoggerService.getInstance();
    return _jsx(LoggingContext.Provider, { value: logger, children: children });
};
/**
 * 默认导出提供者组件
 * 便于导入使用
 */
export default LoggingProvider;
//# sourceMappingURL=LoggingContext.js.map